import { useState } from 'react';
import { RiThumbUpLine, RiThumbDownLine, RiThumbUpFill, RiThumbDownFill } from 'react-icons/ri';

import { IconButton, Stack } from '@mui/material';

import palette from '../theme/palette';

enum LikeDislike {
  LIKE = 'like',
  DISLIKE = 'dislike',
  NONE = 'none'
}

type LikeDislikeButtonsProps = {
  likeCallback: () => void;
  dislikeCallback: () => void;
};

export const LikeDislikeButtons = ({ likeCallback, dislikeCallback }: LikeDislikeButtonsProps) => {
  const [likeDislike, setLikeDislike] = useState<LikeDislike>(LikeDislike.NONE);

  const handleLike = () => {
    setLikeDislike(LikeDislike.LIKE);
    likeCallback();
  };

  const handleDislike = () => {
    setLikeDislike(LikeDislike.DISLIKE);
    dislikeCallback();
  };

  return (
    <Stack direction="row" alignItems="center">
      <IconButton onClick={handleDislike}>
        {likeDislike === LikeDislike.DISLIKE ? (
          <RiThumbDownFill size={16} color={palette.grey[500]} />
        ) : (
          <RiThumbDownLine size={16} color={palette.grey[500]} />
        )}
      </IconButton>
      <IconButton onClick={handleLike}>
        {likeDislike === LikeDislike.LIKE ? (
          <RiThumbUpFill size={16} color={palette.grey[500]} />
        ) : (
          <RiThumbUpLine size={16} color={palette.grey[500]} />
        )}
      </IconButton>
    </Stack>
  );
};
